import { EMPTY_DATE as EMPTY, formatInstantDate } from '@/lib/time';

// Formato de las columnas de la Lista Maestra pedidas en la reunión (QA F1 #10):
// fecha de aprobación, frecuencia de revisión y documentos relacionados. La fecha
// aplicable es una fecha pura y usa formatDate del módulo de tiempo.

/** Día de la aprobación (un instante) en la zona de negocio: "14/07/2026". */
export function formatApproval(iso: string | null): string {
  return formatInstantDate(iso);
}

/** Frecuencia de revisión en palabras: años enteros en años, el resto en días. */
export function formatFrequency(days: number | null): string {
  if (days === null) {
    return EMPTY;
  }
  if (days % 365 === 0) {
    const years = days / 365;
    return years === 1 ? 'cada año' : `cada ${years} años`;
  }
  return days === 1 ? 'cada día' : `cada ${days} días`;
}

/** Códigos de los relacionados ("IT-01, FO-02 +3") o guion si no hay. */
export function formatRelated(related: { count: number; codes: string[] }): string {
  if (related.count === 0) {
    return EMPTY;
  }
  const rest = related.count - related.codes.length;
  return `${related.codes.join(', ')}${rest > 0 ? ` +${rest}` : ''}`;
}
